import classNames from "classnames"
import styles from "./use-sizing.module.scss"

export function useSizing(mainAxis: "fill" | "hug", crossAxis: "fill" | "hug"): string {
  return classNames({
    [styles.mainAxisFill]: mainAxis === "fill",
    [styles.mainAxisHug]: mainAxis === "hug",
    [styles.crossAxisFill]: crossAxis === "fill",
    // NOTE: noop
    // [styles.crossAxisHug]: crossAxis === "hug",
  })
}
